import { render, staticRenderFns } from "./AdFormPromotionLine.vue?vue&type=template&id=0649f59a"
import script from "./AdFormPromotionLine.vue?vue&type=script&lang=ts"
export * from "./AdFormPromotionLine.vue?vue&type=script&lang=ts"
import style0 from "./AdFormPromotionLine.vue?vue&type=style&index=0&id=0649f59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports